var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.page ? _c('Banner', {
    attrs: {
      "page": _vm.page
    }
  }) : _vm._e(), _vm.page ? _c('section', {
    staticClass: "events-page-wrap clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6 left-side"
  }, [_c('h1', [_vm._v(_vm._s(_vm.page["left-section-heading"]))]), _c('br'), _c('p', [_vm._v(_vm._s(_vm.page["left-section-description"]))])]), _c('div', {
    staticClass: "col-sm-6 right-side"
  }, [_c('h1', [_vm._v(_vm._s(_vm.page["right-section-heading"]))]), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submitHandler.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "blockit d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "w-45 form-group"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.form.name,
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "name"
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _vm.submitted && _vm.getError('name') ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" First Name is required ")]) : _vm._e()]), _c('div', {
    staticClass: "w-45 form-group"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.phone,
      expression: "form.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone"
    },
    domProps: {
      "value": _vm.form.phone
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "phone", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.email,
      expression: "form.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email"
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value);
      }
    }
  }), _vm.submitted && _vm.getError('email') ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" A valid email is required ")]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.message,
      expression: "form.message"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "id": "message"
    },
    domProps: {
      "value": _vm.form.message
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "message", $event.target.value);
      }
    }
  }), _vm.submitted && _vm.getError('message') ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._v(" Message must be at least 10 characters long ")]) : _vm._e()]), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "btn-universal border-0 btn-deep-purple",
    attrs: {
      "disabled": _vm.submitted === 'PENDING',
      "type": "submit"
    }
  }, [_vm._v(" Submit ")])])])]), _vm.errors ? _c('div', {
    staticClass: "text-danger ml-5"
  }, [_vm._v(" " + _vm._s(_vm.getErrors) + " ")]) : _vm._e()])])])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }